import { createSlice } from "@reduxjs/toolkit";

/**
 * Sidebar / mobile drawer state.
 *
 * This used to hold the literal CSS string "block" | "none", applied as an
 * inline `style={{display: sideDisplay}}` on the sidebar. That inline value
 * overrode the stylesheet's `display: flex`, silently disabling
 * `#sideItems { flex: 1 }` and `.sidebar-upgrade-link { margin-top: auto }`,
 * and it made the drawer impossible to animate (you cannot transition
 * `display`). It also defaulted to "block", so on mobile the full-screen
 * drawer rendered for one frame on every cold load.
 *
 * It is a boolean now, defaulting to closed, and CSS owns presentation.
 */
export const SideDisplaySlice = createSlice({
  name: "sideDisplay",
  initialState: {
    isOpen: false,
  },
  reducers: {
    openSidebar: (state) => {
      state.isOpen = true;
    },
    closeSidebar: (state) => {
      state.isOpen = false;
    },
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
    setSidebarOpen: (state, action) => {
      state.isOpen = Boolean(action.payload);
    },
  },
});

export const { openSidebar, closeSidebar, toggleSidebar, setSidebarOpen } =
  SideDisplaySlice.actions;

export default SideDisplaySlice.reducer;
